/**
 * @file SideNav Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class SideNav extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.string,
    ]),
    isOpen: PropTypes.bool,
    onClickOutside: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
  };

  componentDidMount() {
    const { isOpen } = this.props;

    if (isOpen) {
      document.addEventListener('click', this.onClickOutside, false);
    }
  }

  componentDidUpdate() {
    const { isOpen } = this.props;

    if (isOpen) {
      document.addEventListener('click', this.onClickOutside, false);
    } else {
      document.removeEventListener('click', this.onClickOutside, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClickOutside, false);
  }

  onClickOutside = event => {
    const { onClickOutside, isOpen } = this.props;

    if (this.content.contains(event.target)) {
      return;
    }

    if (onClickOutside && isOpen) {
      onClickOutside();
    }
  };

  render() {
    const { isOpen, children } = this.props;

    const classes = classNames({
      'side-nav': true,
      'side-nav-open': isOpen,
    });

    return (
      <div className={classes}>
        <div className="side-nav-backdrop" />
        <div
          className="side-nav-content"
          ref={el => {
            this.content = el;
          }}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default SideNav;
